import React from 'react';
import { observer } from 'mobx-react';
import ServerAlert from 'components/server_alert';
import { CreatorUI, AppUI } from '@seedlang/state';
import styled from '@emotion/styled';
import { admin } from '@seedlang/style_mixins';

const Wrapper = styled.div`
  ${admin()}
`;

@observer
class Builder extends React.Component {
  componentDidMount() {
    if (AppUI.routeStore?.routeName === 'creator') {
      AppUI.routeStore.routeToNamed('creator.worksheets.index');
    }
  }

  render() {
    return (
      <Wrapper>
        <div className='creator builder'>
          {CreatorUI.layout.mediaRecorderSupported && this.props.children}
          {
            !CreatorUI.layout.mediaRecorderSupported &&
              <div className='media-recorder-not-supported'>
                <i
                  className='fa fa-warning'
                  style={{
                    margin: '3px 3px 0 0',
                  }}
                />
                The "Creator" section is only supported in Chrome and Firefox.
              </div>
          }
          <ServerAlert />
        </div>
      </Wrapper>
    );
  }
}

export default Builder;